module.exports = __webpack_public_path__ + "img/ปลาตาเดียว.e8b408f2.jpg";